import { useStore } from '../context/StoreContext';
import { Icon } from '../shared/ui/Icon';

export function Footer() {
  const { brand, page, settings, go } = useStore();
  const trustItems = settings?.trustItems || settings?.trustStrip || [];
  const footerLinks = settings?.footerLinks || [];
  const contact = settings?.contact || {};
  const footerText = settings?.text?.publicFooterText?.en
    || settings?.text?.publicFooterText
    || settings?.publicFooterText
    || '';
  const tagline = settings?.tagline?.en || settings?.tagline || '';

  return (
    <footer className="site-footer">
      {page !== 'home' && trustItems.length > 0 && (
        <div className="footer-trust">
          {trustItems.map((item) => (
            <div key={item.id || item.title}>
              <span>{item.icon ? <Icon>{item.icon}</Icon> : null}</span>
              <p><b>{item.title}</b>{item.description && <small>{item.description}</small>}</p>
            </div>
          ))}
        </div>
      )}
      <div className="footer-brand">
        <button className="brand-mark" onClick={() => go('home')} aria-label={`${brand} home`}>
          <img className="brand-logo" src={`${process.env.PUBLIC_URL}/technomax-logo.png`} alt="" />
          <span>{brand.replace(/max/i, '')}</span>
          <b>{brand.match(/max/i)?.[0] || ''}</b>
        </button>
        {tagline && <p>{tagline}</p>}
      </div>
      <div className="footer-links">
        {footerLinks.map((group) => (
          <div key={group.title}>
            <b>{group.title}</b>
            {(group.links || []).map((link) => (
              <a key={link.url || link.label} href={link.url}>{link.label}</a>
            ))}
          </div>
        ))}
        {(contact.phone || contact.email || contact.address) && (
          <div>
            {contact.title && <b>{contact.title}</b>}
            {contact.phone && <a href={`tel:${contact.phone}`}>{contact.phone}</a>}
            {contact.email && <a href={`mailto:${contact.email}`}>{contact.email}</a>}
            {contact.address && <span>{contact.address}</span>}
          </div>
        )}
      </div>
      {footerText && <div className="footer-note">{footerText}</div>}
    </footer>
  );
}
